import { AbstractControl } from '@angular/forms';

export function scheduleDateValidator(control: AbstractControl) {
    const month = control.get('month').value;
    const day = control.get('day').value;
    const year = control.get('year').value;
    const appointmentDate = new Date(`${year}/${month}/${day}`);
    const appointmentTime = new Date(control.get('appointmentTime').value);

    const now = new Date();
    now.setSeconds(0);
    now.setMilliseconds(0);

    const schedule = new Date();
    schedule.setMonth(appointmentDate.getMonth());
    schedule.setDate(appointmentDate.getDate());
    schedule.setFullYear(appointmentDate.getFullYear());
    schedule.setHours(appointmentTime.getHours());
    schedule.setMinutes(appointmentTime.getMinutes());
    schedule.setSeconds(0);
    schedule.setMilliseconds(0);

    if (now.getTime() > schedule.getTime()) {
        return {
            'invalidSchedule': true
        };
    }
    return null;
}



// WEBPACK FOOTER //
// ./src/app/shared/components/schedule-appointment/schedule-date.validator.ts